import type { TFunction } from 'i18next';

// Human-readable имя шаблона для UI. `Template.code` — стабильный snake_case
// идентификатор (резолв override→system, логи), показывать его работнику
// оптики бессмысленно. Бэкенд `Template.name` в M2 не отдаёт — i18n-маппинг
// живёт здесь, единственная точка изменений.
//
// Фаза 2: когда появится UI override с собственным именем (`Template.name`),
// будем использовать `template.name ?? templateDisplayName(t, template.code)`.
export function templateDisplayName(t: TFunction, code: string): string {
  const key = `templates.codes.${code}`;
  const translated = t(key);
  // Если ключа нет — i18next вернёт сам ключ. В этом случае показываем
  // raw code (override от тенанта с произвольным code'ом).
  return translated === key ? code : translated;
}
